import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";

export const fetchPaymentModeChangeDetailsByBillNo = (postObj) => {
  return apiClient.post(`administration/getBillPaymentInfo`, postObj, {
    headers: authHeader(),
  });
};

export const savePaymentModeChangeByBillNo = (postObj) => {
  return apiClient.post(`administration/UpdateBillPaymentModeInfo`, postObj, {
    headers: authHeader(),
  });
};

